var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataGetter',{attrs:{"url":_vm.url,"params":{ CODE_INDICATOR: 'PRICE CONVERTED', Country: _vm.country },"child-element-type":null},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [(data && data.length > 0)?_c('Chart',{attrs:{"title":_vm.title,"units":"USD/MWh","half":_vm.half,"series":_vm.formatData(data),"chartOptions":{
      chart: {
        height: 400,
        spacing: 10,
      },
      xAxis: {
        type: 'category',
      },
    },"palette":"tints"}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }